<div id="technical-details-intro" class="container mx-auto" data-cy="technical-details-intro">
  <div class="form">
    <ife-title
      [title]="'modules.evcQuote.steps.technicalDetails.steps.intro.title' | translate"
      [subtitle]="'modules.evcQuote.steps.technicalDetails.steps.intro.description' | translate"
      data-cy="charging-station-placement-title"
    ></ife-title>

    <div class="flex flex-col mx-auto sm:max-w-4xl mt-8">
      <p>
        {{ "modules.evcQuote.steps.technicalDetails.steps.intro.pictureInfo" | translate }}
      </p>

      <ul class="list">
        <li>{{ "modules.evcQuote.steps.technicalDetails.steps.intro.pictureLocations.fusebox" | translate }}</li>
        <li>{{ "modules.evcQuote.steps.technicalDetails.steps.intro.pictureLocations.mainfuse" | translate }}</li>
        <li>
          {{ "modules.evcQuote.steps.technicalDetails.steps.intro.pictureLocations.placementLocation" | translate }}
        </li>
        <li>
          {{ "modules.evcQuote.steps.technicalDetails.steps.intro.pictureLocations.fuseboxToPlacement" | translate }}
        </li>
      </ul>

      <div class="sm:mx-auto flex flex-col sm:flex-row">
        <button class="btn btn-primary my-4 sm:mx-4" data-cy="continue" (click)="navigate()">
          {{ "modules.evcQuote.steps.technicalDetails.steps.intro.continueNow" | translate }}
        </button>

        <button class="btn btn-secondary my-4 sm:mx-4" data-cy="continue-later" (click)="continueLaterStep()">
          {{ "modules.evcQuote.steps.technicalDetails.steps.intro.finalizeLater" | translate }}
        </button>
      </div>
    </div>

    <!-- QR Code part -->
    <div *ngIf="isDesktopDevice" class="flex flex-col max-w-max mx-auto">
      <div class="line"></div>
      <p class="text-left sm:text-center my-12">
        {{ "modules.evcQuote.general.qrcodeInfo" | translate }}
      </p>

      <div class="qr-section max-w-max mx-auto shadow-lg rounded-lg overflow-hidden">
        <qrcode
          data-cy="qrcode"
          [qrdata]="href"
          [width]="160"
          [errorCorrectionLevel]="'M'"
          [elementType]="'svg'"
        ></qrcode>
      </div>
    </div>

    <ife-navigation [showNext]="false" [showPrevious]="true" (nextStep)="navigate()" (previousStep)="navigateBack()">
    </ife-navigation>
  </div>
</div>
